import React from "react";
import CloneRepo from "../CodeOverview/CloneRepo.jsx";

function CodeRefactoring() {


  return (
    <>
      <CloneRepo />
    </>
  );
}

export default CodeRefactoring;